var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page-footer"}},[_c('div',{staticClass:"space-holder"}),_c('footer',[_c('div',[_vm._v("NitroFire © 2021.")])])])}]

export { render, staticRenderFns }